import { isReportableEnvironment } from "./isReportableEnvironment";
import { ErrorReportOptions, reportError } from "./reportError";
import { reportTrace } from "./reportTrace";

type ConsoleFunctionName = Extract<
  {
    [K in keyof Console]-?: Console[K] extends (...args: unknown[]) => unknown ? K : never;
  }[keyof Console],
  string
>;

type AppLoggerType = ConsoleFunctionName;

type AppLoggerOptions = {
  type?: AppLoggerType;
  event?: string;
  errorReportOptions?: ErrorReportOptions;
};

// Only "error" and "info" are forwarded to Application Insights, and only on BETA/QA/PROD —
// "error" via trackException, "info" via trackTrace (see reportError.ts/reportTrace.ts).
// Business events use trackBusinessEvent()/trackEvent directly, not appLogger. See
// "Business events" in docs/application-insights-rum.md.
export const appLogger = (message: string, options: AppLoggerOptions = {}) => {
  const { type = "debug", event, errorReportOptions } = options;

  const eventName = event ?? (type === "error" ? "FE-ERROR" : type === "info" ? "FE-INFO" : "FE-EVENT");

  if (isReportableEnvironment()) {
    if (type === "error") {
      reportError(message, { eventName, errorMessage: message, ...errorReportOptions });
    } else if (type === "info") {
      reportTrace(message, { eventName, ...errorReportOptions });
    }
  }

  const logMethod = console[type] ?? console.info;
  logMethod(`[APP-LOGGER]: ${message}`);
};
